// extracted by mini-css-extract-plugin
export default {"formWrapper":"CardForm_formWrapper__7hSj4","cardForm":"CardForm_cardForm__TSLP2","label":"CardForm_label__r0NPI"};